import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
  getTicketPaymentStatusColor, StudentTicketPaymentStatusColorMapping
} from "../../../models/student-ticket/payment/StudentTicketPaymentStatusColorMapping";
import {StudentTicketPaymentStatus} from "../../../models/student-ticket/payment/StudentTicketPaymentStatus";
import {StudentTicketPaymentInfoDto} from "../../../models/student-ticket/payment/StudentTicketPaymentInfoDto";
import {AuthService} from "../../../@core/services/auth/auth.service";
import {ModuleConfigService} from "../../../@core/services/module-config/module-config.service";
import {StudentTicketMandateHolderDto} from "../../../models/student-ticket/payment/StudentTicketMandateHolderDto";
import {Land} from "../../../models/land/Land";
import {
  faCoins,
  faCreditCard,
  faLocationDot,
  faMoneyBill,
  faPerson,
  faThumbsUp,
  faLandmark
} from "@fortawesome/free-solid-svg-icons";
import {CurrencyPipe} from "@angular/common";
import {TranslateService} from "@ngx-translate/core";


@Component({
    selector: 'app-ticket-payment-details',
    templateUrl: './ticket-payment-details.component.html',
    styleUrl: './ticket-payment-details.component.scss',
    standalone: false
})
export class TicketPaymentDetailsComponent implements OnInit {

  currencyPipe : CurrencyPipe = new CurrencyPipe("de-DE");
  private _ticketMandateInformation: StudentTicketMandateHolderDto;

  @Input() ticketPaymentInfo: StudentTicketPaymentInfoDto;
  protected ticketPaymentStatus: StudentTicketPaymentStatus;//now in paymentInformation
  @Input() set ticketMandateInformation(value: StudentTicketMandateHolderDto) {
    this._ticketMandateInformation = value;
    this.calculateAddressString(value);
  }

  get ticketMandateInformation(): StudentTicketMandateHolderDto {
    return this._ticketMandateInformation;
  }

  @Output() onMarkTicketPaid = new EventEmitter<void>();
  @Output() onMandateHolderInformationChange = new EventEmitter<void>();

  mandateHolderAddress: string[];
  protected readonly faThumbsUp = faThumbsUp;

  protected isSuperuser: boolean = false;
  protected isSchultraeger: boolean = false;

  constructor(
    public moduleConfigService: ModuleConfigService
  ) {
  }

  ngOnInit(): void {

    this.ticketPaymentStatus = this.ticketPaymentInfo?.paymentStatus?.status;
  }

  markTicketPaid(): void {
    // Implement the method to mark ticket as paid
    this.onMarkTicketPaid.emit();
  }

  triggerChangeMandateHolderInfo(): void {
    this.onMandateHolderInformationChange.emit();
  }

  protected readonly faCreditCard = faCreditCard;
  protected readonly StudentTicketPaymentStatusColorMapping = StudentTicketPaymentStatusColorMapping;


  calculateAddressString(mandateInformation: StudentTicketMandateHolderDto): void {
    const streetAddition = [mandateInformation?.mandateHolderStreet]
      .filter(Boolean)
      .join(' ');

    const plzLocation = [mandateInformation?.mandateHolderPostalCode, mandateInformation?.mandateHolderCity]
      .filter(Boolean)
      .join(' ');

    const country = mandateInformation?.mandateHolderCountry
      ? Land[mandateInformation.mandateHolderCountry] || mandateInformation.mandateHolderCountry
      : undefined;

    this.mandateHolderAddress = [streetAddition, mandateInformation?.mandateHolderAddressAddition, plzLocation, country]

  }


  protected readonly StudentTicketPaymentStatus = StudentTicketPaymentStatus;
  protected readonly getTicketPaymentStatusColor = getTicketPaymentStatusColor;
  protected readonly faPerson = faPerson;
  protected readonly faLocationDot = faLocationDot;
  protected readonly faLandmark = faLandmark;
  protected readonly faMoneyBill = faMoneyBill;
  protected readonly faCoins = faCoins;
}
